export class PaperReport {
    noOfPapers:number = 0;
    noOfQuestions:number = 0;
    noOfCorrectAnswers:number = 0;
    noOfWrongAnswers:number = 0;
    totalReport:number = 0;
    totalMarks: number = 0;
    partOne : number = 0;
    partTwo : number = 0;
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/paperReport.ts